export default "__VITE_ASSET__10vlx_zB__ 150w, __VITE_ASSET__BLS4$t8y__ 300w, __VITE_ASSET__BctBxCM4__ 450w";